const LibBoolean = {
	booleanToStr: (boolean) => {
		if (boolean === true) {
			return "SIM";
		}

		return "NAO";
	},

	strToBoolean: (value) => {
		if (value === "SIM") {
			return true;
		}

		return false;
	},
};

export default LibBoolean;
